import { Component } from '@angular/core';
import { GmDashboardService } from '../gm-dashboard.service';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-addemployee',
  templateUrl: './addemployee.component.html',
  styleUrls: ['./addemployee.component.scss']
})
export class AddemployeeComponent {
  searchemployesslist: any;
  empid: any;
  searchTerm: string = '';
  tempPayrollId: string;
  imageUrl: any;
  // dialogRef: any;
  payrollid: any;
  constructor(private dashboard: GmDashboardService, private dialog1: NgDialogAnimationService, private dailog: MatDialog, public dialogRef: MatDialogRef<AddemployeeComponent>, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {

  }
  employessearch() {
    console.log("employess", this.searchTerm);
    // if (this.searchTerm.length >= 9) {
    this.dashboard.getemployesssearch(this.searchTerm).subscribe((res: any) => {
      this.searchemployesslist = res
      this.empid = this.searchemployesslist.empId
      this.tempPayrollId = this.searchemployesslist.payrollId
      this.getImage(this.searchemployesslist)
      this.searchTerm = ''
    })
    // }
    //    else {
    //   window.alert("Please Enter the Vaild Complected PayrollId ")
    // }
    // this.searchTerm=''

  }
  cardopen(emp: any) {

    this.dialogRef.close(emp)
  }
  getImage(emp: any) {
    const payrollId = emp.payrollId || emp.payRollId;
    this.dashboard.getimage(payrollId).subscribe({
      next: (blob: Blob) => {
        this.spinner.show();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.imageUrl = reader.result as string;
          this.spinner.hide();

        };
      },
      error: (err: any) => {
        this.imageUrl = '../../../../../assets/images/employee_notpresent.jpg'
        this.spinner.hide();
      }
    })
  }
}
